/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconDevelopers/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconDevelopers({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconDevelopers",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconDevelopers.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-b0oV0': alignSelf,'--mt-2-b0oV0': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-b0oV0': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-b0oV0': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-b0oV0': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-b0oV0': opacity,'--w-10-b0oV0': typeof width === 'number' ? `${width}px` : width,'--h-11-b0oV0': typeof height === 'number' ? `${height}px` : height,'--f-12-b0oV0': fill,'--a-7-b0oV0': isAnimated ? animation : "none",'--sd-8-b0oV0': isAnimated ? strokeDashoffset : 0,'--sd-9-b0oV0': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconDevelopers.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M16.94 6c.207 0 .375.168.375.375v5.936H6.674V6.375c0-.207.168-.375.375-.375h9.891zm2.625.375A2.625 2.625 0 0016.94 3.75H7.05a2.625 2.625 0 00-2.625 2.625v6.917l-2.47 3.294c-1.112 1.484-.054 3.6 1.8 3.6h16.492c1.854 0 2.912-2.116 1.8-3.6l-2.48-3.309V6.375z"
 style={{'--f-12-b0oV0': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}